import type { ChatMessageVariant } from "app/pages/sales-intelligence/modules/ai-agent/components/ChatMessage/types";
import { AI_AGENT_PAGE_WIDTH } from "app/pages/sales-intelligence/modules/ai-agent/constants";

export type AgentChatTheme = "full-page" | "embedded" | "super-agent";

export type AgentChatThemeValue = {
    readonly msgBorderRadius: string;
    readonly msgMaxWidth: Partial<Record<ChatMessageVariant, string>> | string;
    readonly msgPadding: Partial<Record<ChatMessageVariant, string>> | string;
    readonly msgBlockGapY: string;
    readonly msgContainerMinWidth?: string;
};

export const CHAT_THEME: Record<AgentChatTheme, AgentChatThemeValue> = {
    embedded: {
        msgBorderRadius: "8px",
        msgPadding: {
            human: "10px 12px",
            ai: "0",
        },
        msgMaxWidth: {
            human: "240px",
            ai: "296px",
        },
        msgBlockGapY: "16px",
    },
    "full-page": {
        msgBorderRadius: "30px",
        msgPadding: {
            human: "8px 24px",
            company: "8px 24px",
            ai: "4px 0",
        },
        msgMaxWidth: `${AI_AGENT_PAGE_WIDTH}px`,
        msgContainerMinWidth: `${AI_AGENT_PAGE_WIDTH}px`,
        msgBlockGapY: "52px",
    },
    "super-agent": {
        msgBorderRadius: "30px",
        msgPadding: {
            human: "8px 24px",
            company: "8px 24px",
            ai: "4px 0",
        },
        msgMaxWidth: {
            human: "560px",
            ai: "724px",
        },
        msgContainerMinWidth: "724px",
        msgBlockGapY: "52px",
    },
};
